import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../../hooks/useTheme.js';
import { Box } from '../../Box/index.js';

var CoachTipBase = function (_a) {
    var Icon = _a.icon, children = _a.children, _b = _a.themeKey, themeKey = _b === void 0 ? "coachTip" : _b, props = __rest(_a, ["icon", "children", "themeKey"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var _c = handleStyleProps(props, {
        themeKey: themeKey,
    }), css = _c.css, forwardProps = __rest(_c, ["css"]);
    return (jsxs(Box, __assign({ css: css }, forwardProps, { children: [jsx(Icon, { className: "icon" }), jsx(Box, { children: children })] })));
};
CoachTipBase.displayName = "CoachTipBase";

export { CoachTipBase };
//# sourceMappingURL=index.js.map
